import 'react-toastify/dist/ReactToastify.min.css';

import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { MuiPickersUtilsProvider } from '../wrappers/MuiPickersUtilsProvider';
import { RefreshIfNeeded } from '../wrappers/RefreshIfNeeded';
import { IntlWrapper } from '../../../libs/IdeLink.Web.Common/src/components/Templates/IntlWrapper/intlWrapper';
import { EssentialInfo } from '../../../libs/IdeLink.Web.Common/src/components/Templates/EssentialInfo/EssentialInfo';
import { PersistGate } from '../../../libs/IdeLink.Web.Common/src/components/Templates/PersistGate/PersistGate';
import { AuthGate } from '../../../libs/IdeLink.Web.Common/src/components/Templates/AuthGate/AuthGate';
import { PermissionsGate } from '../../../libs/IdeLink.Web.Common/src/components/Templates/PermissionsGate/PermissionsGate';
import { LazyLoader } from '../../../libs/IdeLink.Web.Common/src/components/Templates/LazyLoader/LazyLoader';

export interface AppWrapperBaseProps {
    readonly store: any;
    readonly persistor: any;
    readonly importLocaleData?: () => Promise<any>;
}

export const AppWrapperBase = ({
    store,
    persistor,
    children,
    importLocaleData,
}: React.PropsWithChildren<AppWrapperBaseProps>) => (
    <MuiPickersUtilsProvider>
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <IntlWrapper importLocaleData={importLocaleData}>
                    <EssentialInfo>
                        <AuthGate>
                            <PermissionsGate>
                                <RefreshIfNeeded timeout={30 * 60 * 1000}>
                                    <LazyLoader delay={3 * 1000}>
                                        <div style={{ height: '100%' }}>
                                            {children}
                                            <ToastContainer hideProgressBar autoClose={8000} />
                                        </div>
                                    </LazyLoader>
                                </RefreshIfNeeded>
                            </PermissionsGate>
                        </AuthGate>
                    </EssentialInfo>
                </IntlWrapper>
            </PersistGate>
        </Provider>
    </MuiPickersUtilsProvider>
);
